import { render } from "./Forgotpassword.vue?vue&type=template&id=5940f08e&scoped=true"
import script from "./Forgotpassword.vue?vue&type=script&lang=js"
export * from "./Forgotpassword.vue?vue&type=script&lang=js"

import "./Forgotpassword.vue?vue&type=style&index=0&id=5940f08e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5940f08e"]])

export default __exports__